import './Aside.scss';

import cn from 'classnames';
import React from 'react';
import Barcode from 'react-barcode';
import { Trans, useTranslation } from 'react-i18next';

import { ReactComponent as CheckIcon } from '@/materiaux/assets/icons/check.svg';

import { AsideDefaultProps, AsidePropTypes } from './Aside.proptypes';

const Aside = ({ className, order, warehouse }) => {
  const { t } = useTranslation();

  return (
    <div className={cn('scanbat-checkout-confirm-content', className)}>
      <div className="scanbat-checkout-confirm-aside__success success">
        <div className="success__icon">
          <CheckIcon className="icon" />
        </div>
        <div className="success__label">
          <Trans
            allowHTML
            components={{ span: <span /> }}
            i18nKey="ebat:entities:scanbat.checkout_confirm.success"
          />
        </div>
      </div>
      <div className="scanbat-checkout-confirm-aside__barcode">
        <Barcode value={order.number.toString()} />
      </div>
      <div className="scanbat-checkout-confirm-aside__warehouse">
        {t('ebat:entities:scanbat.checkout_confirm.warehouse', {
          warehouse: warehouse.name,
        })}
      </div>
    </div>
  );
};

Aside.defaultProps = {
  ...AsideDefaultProps,
};

Aside.propTypes = {
  ...AsidePropTypes,
};

export default Aside;
